<template>
  <div>
    <!-- <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="get_list" type="primary" class="search">{{
          $t("search_zh")
        }}</el-button>
        <el-button @click="reset" type="info">{{
          $t("btnTip.reset")
        }}</el-button>
      </el-row>
    </el-card> -->
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <div></div>
        <el-button type="primary" @click="handleClick('add')">{{ $t("notification").sendNotification }}</el-button>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
        <template v-slot:auth="slotProps">
          <div>
            <el-tag :type="authTag(slotProps.callback.row.auth)">{{
              auth(slotProps.callback.row.auth)
            }}</el-tag>
          </div>
        </template>
        <template v-slot:active="slotProps">
          <div>
            <el-tag :type="activeTag(slotProps.callback.row.active)">{{
              active(slotProps.callback.row.active)
            }}</el-tag>
          </div>
        </template>
        <template v-slot:operation="slotProps">
          <el-tooltip
            class="item"
            effect="dark"
            :content="
              slotProps.callback.row.active === 0
                ? $t('accountManagement').active1
                : $t('accountManagement').active0
            "
            placement="top"
          >
            <el-button
              @click="handleClick('active', slotProps.callback.row)"
              :type="
                slotProps.callback.row.active === 0 ? 'success' : 'warning'
              "
              size="mini"
              >{{
                slotProps.callback.row.active === 0
                  ? $t("accountManagement").active1
                  : $t("accountManagement").active0
              }}</el-button
            >
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').resetPW"
            placement="top"
          >
            <el-button
              @click="handleClick('edit', slotProps.callback.row)"
              type="info"
              size="mini"
              >{{ $t("btnTip").resetPW }}</el-button
            >
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').delete"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              @click="del(slotProps.callback.row.id)"
              >{{ $t("btnTip").delete }}</el-button
            >
          </el-tooltip>
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="800px">
      <form-page
        :ref-obj.sync="formInfo.ref"
        :data="formInfo.data"
        :field-list="formInfo.fieldList"
        :rules="formInfo.rules"
        :label-width="formInfo.labelWidth"
        :list-type-info="listTypeInfo"
        :disabled="formInfo.disabled"
      >
      <span slot="form-item-tips" style="color:red">
        APP으로 접속하신 모든 사용자에게 보내는 내용입니다.
      </span>
      </form-page>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" type="info" class="ml30">{{
          $t('btnTip.cancel')
        }}</el-button>
        <el-button @click="done('managerForm')" type="primary" class="ml30">{{
          $t('notification.send')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mixin_list } from "@/mixins";
import page from "@/components/page";
import myTable from "@/components/table";
import FormPage from "@/components/FormPage";
import { fcm_log, post_fcm_log } from "@/api/api";
const formInfoData = {
  title: "",
  msg: "",
};
export default {
  name: "accountManagement",
  mixins: [mixin_list(fcm_log)],
  components: {
    myTable,
    FormPage,
    page,
  },
  data() {
    return {
      filter: {
        search: "",
      },
      columns: [
        {
          label: "ID",
          sortable: true,
          prop: "id",
          width: 80,
        },
        {
          label: this.$t("notification.create_time"),
          sortable: true,
          prop: "create_time",
          width:"180"
        },
        {
          label: this.$t("notification.title"),
          sortable: true,
          prop: "title",
          width:"400"
        },
        {
          label: this.$t("notification.msg"),
          sortable: true,
          prop: "msg",
        },
        // {
        //   label: this.$t("operation"),
        //   prop: "",
        //   width: 300,
        //   slot: "operation",
        // },
      ],
      formInfo: {
        ref: null,
        disabled: false,
        data: formInfoData,
        fieldList: [
          {
            label: this.$t("notification").title,
            value: "title",
            width: "550",
            type: "input",
            className: "el-form-block",
            required: true,
            hidden: false,
          },
          {
            label: this.$t("notification").msg,
            value: "msg",
            type: "textarea",
            width: "550",
            className: "el-form-block",
            required: true,
            hidden: false,
          },
          {
            value: "tips",
            slot:true,
            width: "550",
            className: "el-form-block",
            required: false,
            hidden: false,
          }
        ],
        rules: {},
        labelWidth: "120px",
      },
      listTypeInfo: {},
      dialogFormVisible: false,
      which: "",
    };
  },
  computed: {
    title() {
      return this.$t("notification").sendNotification
    },
  },
  methods: {
    async handleClick(type, data) {
      switch (type) {
        case "add":
          this.formInfo.data = {...formInfoData};
          this.initRules();
          this.formInfo.disabled = type !== "check" ? false : true;
          this.dialogFormVisible = true;
          this.which = type;
          break;
      }
    },
    done() {
      switch (this.which) {
        case "add":
          this.formInfo.ref.validate(async (valid) => {
            if (valid) {
              await post_fcm_log(this.formInfo.data);
              this.get_list();
            }
          });
          break;
      }
      this.dialogFormVisible = false;
    }
  },
};
</script>